import { useEffect, useState } from 'react';
import { FunctionComponent } from 'react';
import TopMenu from '../shared/top-menu/top-menu';
import Footer from '../shared/footer/footer';
import './showcases.scss';
import ShowcaseBusinessIntelligence from './businessintelligence/showcase-businessintelligence';
import ShowcaseMarketresearch from './marketresearch/showcase-marketresearch';
import ShowcaseHealthcare from './healthcare/showcase-healthcare';
import ShowcasePolitics from './politics/showcase-politics';
import ShowcaseFinance from './finance/showcase-finance';
import ShowcaseProductquality from './productquality/showcase-productquality';
import ShowcaseEducation from './education/showcase-education';
import ShowcaseMunicipaladministration from './municipaladministration/showcase-municipaladministration';
import ShowcasesTopBanner from './showcases-banner';
import ShowcasesMenu, { ShowcasesMenuItems } from './showcases-menu';
import BuyNowButton from '../shared/buy-now-button/buy-now-button';
import { Helmet } from 'react-helmet-async';

export type Props = {};

const Showcases: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  const [showcase, setShowcase] = useState<string | undefined>(undefined);

  useEffect(() => {
    const path = window.location.pathname;
    const parts = path.split('/');
    if (parts.length > 3) {
      setShowcase(parts[3]);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>PS IMAGO PRO - Showcases</title>
        <meta
          name="description"
          content="Entdecke die vielfältigen Anwendungsfälle von PS IMAGO PRO in verschiedenen Branchen. Von Business Intelligence über Gesundheitswesen bis hin zu Bildung und Kommunalverwaltung."
        />
        <meta
          name="keywords"
          content="Showcases, PS IMAGO PRO, Business Intelligence, Marktforschung, Gesundheitswesen, Politik, Finanzen, Produktqualität, Bildung, Kommunalverwaltung"
        />
        <link rel="canonical" href="https://predictivesolutions.2x4.de/de/showcases" />
      </Helmet>
      <div className="page showcases">
        <TopMenu selected={undefined}></TopMenu>
        <ShowcasesTopBanner />
        <ShowcasesMenu selected={('showcases/' + showcase) as ShowcasesMenuItems} />
        {/* =========================================================================================== */}
        <div className="page-content bg-1">
          <div className="inner-content">
            {showcase === 'businessintelligence' && <ShowcaseBusinessIntelligence />}
            {showcase === 'marketresearch' && <ShowcaseMarketresearch />}
            {showcase === 'healthcare' && <ShowcaseHealthcare />}
            {showcase === 'politics' && <ShowcasePolitics />}
            {showcase === 'finance' && <ShowcaseFinance />}
            {showcase === 'productquality' && <ShowcaseProductquality />}
            {showcase === 'education' && <ShowcaseEducation />}
            {showcase === 'municipaladministration' && <ShowcaseMunicipaladministration />}
          </div>
        </div>
        {/* =========================================================================================== */}
        <div className="page-content bg-1">
          <div className="inner-content">
            <center>
              <BuyNowButton order="buy" />
            </center>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </>
  );
};

export default Showcases;
